import { LuDownload } from 'react-icons/lu';
import styles from '../../styles/mainContent/Home.module.css';
import { getResumeUrl } from '../../utils/resumeUtils';
import { wrapIcon } from '../../utils/iconWrapper';

const ResumeIcon = wrapIcon(LuDownload);

const ResumeDownload = () => {
    return (
        <div style={{ textAlign: 'center' }} >
          <a
            href={getResumeUrl()}
            target="_blank"
            rel="noreferrer"
            className={styles.resumeButton}
          >
            <ResumeIcon /> View Resume
          </a>
        </div>
    )
}

export default ResumeDownload;